import {Action} from '@ngrx/store';
import * as _ from 'lodash';
import {DEFAULT_PAGE_SIZE} from '../../shared';
import {ShippingsFilter, ShippingsList} from '../models/shippings-list';
import {SelectedItem} from '../../order/models/order';
import {
  ChangeShippingsPageSizeAction, LoadShippingsSuccessAction, OrderShippingsByAction, PageShippingsToAction,
  QuickSearchShippingsAction, SearchShippingsAction,
  shippingListActionTypes,
  ToggleSearchShippingsAction
} from '../actions/shipping-list';

export interface ShippingsState {
  array: ShippingsList[];
  showFilter: boolean;
  quickSearch: string;
  filter: ShippingsFilter;
  page: number;
  pageSize: number;
  orderBy: string;
  count: number;
  selectedShipping: SelectedItem[];
}

const initialState: ShippingsState = {
  array: undefined,
  showFilter: false,
  quickSearch: undefined,
  filter: undefined,
  page: 1,
  pageSize: DEFAULT_PAGE_SIZE,
  orderBy: 'created descending',
  count: 0,
  selectedShipping: [],
};

export function ShippingsListReducer(state: ShippingsState = initialState, action: Action): ShippingsState {
  switch (action.type) {

    case shippingListActionTypes.TOGGLE_SEARCH:
      return handleToggleSearchAction(state, action);
    case shippingListActionTypes.QUICK_SEARCH:
      return handleQuickSearchAction(state, action);
    case shippingListActionTypes.SEARCH:
      return handleSearchAction(state, action);
    case shippingListActionTypes.PAGE_TO:
      return handlePageToAction(state, action);
    case shippingListActionTypes.CHANGE_PAGE_SIZE:
      return handleChangePageSizeAction(state, action);
    case shippingListActionTypes.ORDER_BY:
      return handleOrderByAction(state, action);
    case shippingListActionTypes.LOAD_SUCCESS:
      return handleLoadSuccessAction(state, action);
    case shippingListActionTypes.LOAD_FAIL:
      return handleLoadErrorActions(state);
    case shippingListActionTypes.CLEAR:
      return handleLoadClearActions();
    default:
      return state;
  }
}

function handleToggleSearchAction(state: ShippingsState, action: ToggleSearchShippingsAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    showFilter: action.payload,
    selectedShipping: []
  };
  return newState;
}

function handleQuickSearchAction(state: ShippingsState, action: QuickSearchShippingsAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    quickSearch: action.payload,
    page: 1,
    selectedShipping: []
  };
  return newState;
}

function handleSearchAction(state: ShippingsState, action: SearchShippingsAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    filter: action.payload.data,
    page: 1,
    selectedShipping: []
  };
  return newState;
}

function handlePageToAction(state: ShippingsState, action: PageShippingsToAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    page: action.payload,
    selectedShipping: []
  };
  return newState;
}

function handleLoadSuccessAction(state: ShippingsState, action: LoadShippingsSuccessAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    array: action.payload.array,
    count: action.payload.count,
    selectedShipping: []
  };
  return newState;
}


function handleChangePageSizeAction(state: ShippingsState, action: ChangeShippingsPageSizeAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    page: 1,
    pageSize: action.payload,
    selectedShipping: []
  };
  return newState;
}
function handleOrderByAction(state: ShippingsState, action: OrderShippingsByAction): ShippingsState {
  const newState: ShippingsState = {
    ... state,
    orderBy: action.payload,
    selectedShipping: []
  };
  return newState;
}

function handleLoadClearActions(): ShippingsState {
  const newState: ShippingsState = {
    array: undefined,
    showFilter: false,
    quickSearch: undefined,
    filter: undefined,
    page: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    orderBy: 'created descending',
    count: 0,
    selectedShipping: [],
  };
  return newState;
}

function handleLoadErrorActions(state: ShippingsState): ShippingsState {
  return state;
}


export const shippingsListSelectors = {
  showFilter: (state: ShippingsState) => _.get(state, 'showFilter', false),
  quickSearch: (state: ShippingsState) => _.get(state, 'quickSearch'),
  filter: (state: ShippingsState) => _.get(state, 'filter'),
  page: (state: ShippingsState) => _.get(state, 'page', 1),
  pageSize: (state: ShippingsState) => _.get(state, 'pageSize', DEFAULT_PAGE_SIZE),
  orderBy: (state: ShippingsState) => _.get(state, 'orderBy'),
  array: (state: ShippingsState) => _.get(state, 'array', []),
  count: (state: ShippingsState) => _.get(state, 'count', 0),
  selectedShipping: (state: ShippingsState) => _.get(state, 'selectedShipping', [])
};
